module.exports = __webpack_public_path__ + "ge.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/ge.svg
// module id = 815
// module chunks = 0